import React from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { ThemeProvider } from '@emotion/react'
import { BiometricsPage, SignUpPageHeader } from '.'
import { FailedMessage } from './Message/FailedMessage'
import { isReactNativeApp } from '@mobi/web-native-comms/web'
import { newTheme } from '@mobi/component-library/Theme'
import { routes } from '../Utils'
import { SignUpPageBodyStyled } from './SignUpPage.styled'

export const SignUpPage = () => {
  return (
    <ThemeProvider theme={newTheme}>
      <SignUpPageHeader />
      <SignUpPageBodyStyled>
        <Routes>
          <Route path={routes.contactDetails} />

          <Route path={routes.contactDetailsError}>
            <FailedMessage />
          </Route>

          <Route
            path={routes.biometrics}
            element={isReactNativeApp ? <Navigate to={routes.depositLimit} /> : <BiometricsPage />}
          />

          <Route path={routes.verificationFailed}>
            <FailedMessage />
          </Route>
        </Routes>
      </SignUpPageBodyStyled>
    </ThemeProvider>
  )
}

SignUpPage.displayName = 'SignUpPage'

// For lazy loading
export default SignUpPage
